/**
 * The canonical URL for the page currently being viewed.
 *
 * Built from origin + pathname rather than window.location.href on purpose:
 * href carries query strings and hashes, so a visit from an ad or a newsletter
 * (?utm_source=…) would declare a canonical that differs from the one crawlers
 * were given — which reads to an audit tool as "canonical points to a
 * different page".
 */
export const canonicalUrl = () =>
  `${window.location.origin}${window.location.pathname}`;
